import React from 'react';
import { List } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import LanguageFlag from '@components/LanguageFlag';
import { selectLanguages } from '@redux/core/reducers';
import { selectCurrentDashboardUser } from '@redux/login/reducer';
import { resolveLanguageCode } from '@utils/supportedLanguages';

const LanguagesSelectorPopup = () => {
  const currentDashboardUser = useSelector(selectCurrentDashboardUser);
  const languages = useSelector(selectLanguages);
  const { i18n } = useTranslation();

  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
    localStorage.setItem(`${currentDashboardUser.email}-language`, lng);
    window.location.reload();
  };

  return (
    <List
      className="user-change-language-popover-list"
      size="small"
      dataSource={languages}
      bordered={false}
      split={false}
      renderItem={item => (
        <List.Item className="user-change-language-items" onClick={() => changeLanguage(item.key)}>
          <span className="user-change-language-label">
            <LanguageFlag icon={item.icon} className="user-change-language-icon" />
            {item.untranslatedName}
          </span>
          {resolveLanguageCode(i18n.language) === item.key ? (
            <FontAwesomeIcon icon={faCheck} className="current-language" />
          ) : null}
        </List.Item>
      )}
    />
  );
};

export default LanguagesSelectorPopup;
